import { Component, OnInit } from '@angular/core';
import { MixpanelService } from '@app/_services/mixpanel.service';

@Component({
  selector: 'app-my-account',
  templateUrl: './my-account.component.html'
})
export class MyAccountComponent implements OnInit {

  constructor(private mixpanel: MixpanelService) { }

  ngOnInit(): void {
    this.mixpanel.track('Account Page');
  }

}
